import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function MyOrders(accessToken) {
  return {
    type: Pre.API + Actions.MY_ORDERS,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function MyFacilityList(accessToken) {
  return {
    type: Pre.API + Actions.MY_FACILITY_LIST,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
export function MyCarWashOrders(accessToken) {
  return {
    type: Pre.API + Actions.MY_CARWASH_ORDERS,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function MyCoffeeShopAndRestaurantOrders(accessToken) {
  return {
    type: Pre.API + Actions.MY_COFFEESHOP_AND_RESTAURANT_ORDERS,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function MyTransactions(accessToken, orderUnitIds) {
  return {
    type: Pre.API + Actions.MY_TRANSACTIONS,
    accessToken,
    payload: orderUnitIds,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function MyParkingOrders(accessToken) {
  return {
    type: Pre.API + Actions.MY_PARKING_ORDERS,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
